/* ================================
   FORCE HEADER SEARCH OPEN (DESKTOP)
================================ */

// document.addEventListener('DOMContentLoaded', function () {

//   function keepSearchOpen() {

//     if (window.innerWidth >= 990) {

//       const searchDetails = document.querySelector(
//         '.header details-modal details'
//       );

//       if (searchDetails && !searchDetails.hasAttribute('open')) {
//         searchDetails.setAttribute('open', 'open');
//       }

//     }

//   }

//   /* Run immediately */
//   keepSearchOpen();

//   /* Re-run when header script closes it */
//   document.addEventListener('scroll', keepSearchOpen);

//   /* Re-run on resize */
//   window.addEventListener('resize', keepSearchOpen);

// });



/* =========================================
   TOGGLE DEFAULT SEARCH (NO STYLE BREAKING)
========================================= */

document.addEventListener('DOMContentLoaded', function () {

  function handleSearch() {

    const header = document.querySelector('.section-header');
    const details = document.querySelector('.header details-modal details');

    if (!header || !details) return;

    if (window.innerWidth >= 990) {

      if (header.classList.contains('scrolled-past-header')) {
        // Sticky header → default behavior
        details.removeAttribute('open');
      } else {
        // Top header → auto open search
        details.setAttribute('open', 'open');
      }

    }

  }

  /* Run */
  handleSearch();

  window.addEventListener('scroll', handleSearch);
  window.addEventListener('resize', handleSearch);

});





/* ================================
   SMOOTH SCROLL WITH OFFSET
================================ */

document.addEventListener("DOMContentLoaded", function () {

  const OFFSET = 120; // Adjust based on header height

  function smoothScrollToTarget(targetId) {
    const target = document.querySelector(targetId);

    if (!target) return;

    const elementPosition =
      target.getBoundingClientRect().top + window.pageYOffset;

    const offsetPosition = elementPosition - OFFSET;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }

  /* Handle menu clicks */

  document.querySelectorAll('a[href*="#"]').forEach(function (anchor) {

    anchor.addEventListener("click", function (e) {

      const url = new URL(this.href);

      const currentUrl =
        window.location.pathname + window.location.search;

      const targetUrl =
        url.pathname + url.search;

      const targetId = url.hash;

      if (!targetId) return;

      if (currentUrl === targetUrl) {
        e.preventDefault();
        smoothScrollToTarget(targetId);
        history.pushState(null, null, targetId);
      }

    });

  });

  /* Handle page load with hash */

  if (window.location.hash) {

    setTimeout(function () {

      smoothScrollToTarget(window.location.hash);

    }, 200);

  }

});



// Custom Banner Slider

document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      $('.custom-banner-slider .slider-wrapper').not('.slick-initialized').slick({
        infinite: true,
        arrows: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
        prevArrow: `<button type="button" class="slick-prev" aria-label="Previous Slide"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 2L2 10L10 18" stroke="currentColor" stroke-width="2"/>
          </svg>
          </button>`,
        nextArrow: `<button type="button" class="slick-next" aria-label="Next Slide"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 2L10 10L2 18" stroke="currentColor" stroke-width="2"/>
              </svg>
              </button>`
      });
    }, 100); // Delay ensures all Liquid-rendered blocks are in place
});



// Custom Collection Tabs Section

// const slider = document.querySelector('.ct-tabs__list');

// let isDown = false;
// let startX;
// let scrollLeft;

// slider.addEventListener('mousedown', (e) => {
//   isDown = true;
//   slider.classList.add('dragging');
//   startX = e.pageX - slider.offsetLeft;
//   scrollLeft = slider.scrollLeft;
// });

// slider.addEventListener('mouseleave', () => {
//   isDown = false;
// });

// slider.addEventListener('mouseup', () => {
//   isDown = false;
// });

// slider.addEventListener('mousemove', (e) => {
//   if (!isDown) return;
//   e.preventDefault();
//   const x = e.pageX - slider.offsetLeft;
//   const walk = (x - startX) * 1.5;
//   slider.scrollLeft = scrollLeft - walk;
// });




// Testimonial Slider Section

// document.addEventListener('DOMContentLoaded', function () {
//   var $carousel = $('.testimonials-carousel');

//   // Initialize Slick
//   $carousel.slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     infinite: false,
//     autoplay: false,
//     arrows: true,
//     dots: true,
//     accessibility: false,
//     responsive: [
//       { breakpoint: 1200, settings: { slidesToShow: 3 } },
//       { breakpoint: 1024, settings: { slidesToShow: 2 } },
//       { breakpoint: 768, settings: { slidesToShow: 1 } }
//     ]
//   });

//   function updateArrows() {
//     var $prevArrow = $carousel.find('.slick-prev');
//     var $nextArrow = $carousel.find('.slick-next');
//     var current = $carousel.slick('slickCurrentSlide');
//     var slideCount = $carousel.slick('getSlick').slideCount;
//     var slidesToShow = $carousel.slick('getSlick').options.slidesToShow;

//     // Disable previous button if on first slide
//     if (current === 0) {
//       $prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
//     } else {
//       $prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
//     }

//     // Disable next button if on (last possible start slide)
//     if (current >= slideCount - slidesToShow) {
//       $nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
//     } else {
//       $nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
//     }
//   }

//   // Update arrows initially and on every slide change
//   updateArrows();
//   $carousel.on('afterChange', updateArrows);
// });



// Testimonial Slider Section New Code

document.addEventListener('DOMContentLoaded', function () {

  var $carousel = $('.testimonials-carousel');

  // Stop if slider not present
  if (!$carousel.length) return;

  // Initialize Slick only once
  if (!$carousel.hasClass('slick-initialized')) {
    $carousel.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      autoplay: false,
      arrows: true,
      dots: true,
      accessibility: false,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 3 } },
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 1 } }
      ]
    });
  }

  function updateArrows() {

    // Safety check
    if (!$carousel.hasClass('slick-initialized')) return;

    var slick = $carousel.slick('getSlick');

    // Extra safety
    if (!slick || !slick.options) return;

    var $prevArrow = $carousel.find('.slick-prev');
    var $nextArrow = $carousel.find('.slick-next');

    var current = slick.currentSlide;
    var slideCount = slick.slideCount;
    var slidesToShow = slick.options.slidesToShow;

    // Previous arrow
    if (current === 0) {
      $prevArrow.addClass('slick-disabled')
        .attr('aria-disabled', 'true');
    } else {
      $prevArrow.removeClass('slick-disabled')
        .attr('aria-disabled', 'false');
    }

    // Next arrow
    if (current >= slideCount - slidesToShow) {
      $nextArrow.addClass('slick-disabled')
        .attr('aria-disabled', 'true');
    } else {
      $nextArrow.removeClass('slick-disabled')
        .attr('aria-disabled', 'false');
    }
  }

  // Run after slick initializes
  $carousel.on('init afterChange', function () {
    updateArrows();
  });

  updateArrows();

});



// Footer Logo Marquee Section

document.addEventListener("DOMContentLoaded", function () {

  const track = document.getElementById("logoMarqueeTrack");

  if (!track) return;

  function checkOverflow() {
    const parentWidth = track.parentElement.offsetWidth;
    const contentWidth = track.scrollWidth;

    if (contentWidth > parentWidth) {
      track.classList.add("animate");
    } else {
      track.classList.remove("animate");
    }
  }

  checkOverflow();

  window.addEventListener("resize", checkOverflow);

});



// Ingredients Section 

// document.addEventListener('DOMContentLoaded', function () {
//   const section = document.querySelector('.native-ingredients-section');
//   if (!section) return;

//   const slider = section.querySelector('.native-ingredients-section__grid');
//   const dotsContainer = section.querySelector('[data-slider-dots]');
//   const slides = slider.querySelectorAll('.native-ingredients-section__item');

//   if (!slider || !dotsContainer || slides.length === 0) return;

//   // Create dots
//   slides.forEach((_, index) => {
//     const dot = document.createElement('button');
//     dot.className = 'native-ingredients-section__dot';

//     dot.addEventListener('click', () => {
//       const slide = slides[index];
//       slider.scrollTo({
//         left: slide.offsetLeft,
//         behavior: 'smooth'
//       });
//     });

//     dotsContainer.appendChild(dot);
//   });

//   const dots = dotsContainer.querySelectorAll('.native-ingredients-section__dot');

//   function updateActiveDot() {
//     let index = 0;
//     const scrollLeft = slider.scrollLeft;

//     slides.forEach((slide, i) => {
//       if (scrollLeft >= slide.offsetLeft - slide.offsetWidth / 2) {
//         index = i;
//       }
//     });

//     dots.forEach(dot => dot.classList.remove('active'));
//     if (dots[index]) dots[index].classList.add('active');
//   }

//   slider.addEventListener('scroll', updateActiveDot);

//   // Set first active
//   if (dots[0]) dots[0].classList.add('active');
// });

// New Code
document.addEventListener('DOMContentLoaded', function () {
  var $carousel = $('.native-ingredients-section__grid');

  if(window.innerWidth < 1025){
     // Initialize Slick
    $carousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: false,
      arrows: false,
      dots: true,
      mobileFirst: true,
      responsive: [
        { breakpoint: 1025, settings:'unslick' },
        // { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 767, settings: { slidesToShow: 2 } }
      ]
    });
  }
 

})
// document.addEventListener('DOMContentLoaded', function () {
//   const section = document.querySelector('.native-ingredients-section');
//   if (!section) return;

//   const slider = section.querySelector('.native-ingredients-section__grid');
//   const dotsContainer = section.querySelector('[data-slider-dots]');
//   if (!slider) return;

//   let slides = slider.querySelectorAll('.native-ingredients-section__item');
//   if (slides.length === 0) return;

//   let slidesPerView = 1;
//   let isRepositioning = false;
//   let scrollTimeout;

//   /* -----------------------------
//      GET SLIDES PER VIEW
//   ----------------------------- */

//   function getSlidesPerView() {
//     const sliderWidth = slider.offsetWidth;
//     const slideWidth = slides[0].offsetWidth;

//     if (!slideWidth) return 1;

//     return Math.round(sliderWidth / slideWidth);
//   }

//   /* -----------------------------
//      CREATE CLONES
//   ----------------------------- */

//   function createClones() {
//     slides = slider.querySelectorAll('.native-ingredients-section__item');

//     slidesPerView = getSlidesPerView();

//     const total = slides.length;

//     for (let i = 0; i < slidesPerView; i++) {
//       const firstClone = slides[i].cloneNode(true);
//       const lastClone = slides[total - 1 - i].cloneNode(true);

//       firstClone.classList.add('clone');
//       lastClone.classList.add('clone');

//       slider.appendChild(firstClone);
//       slider.insertBefore(lastClone, slider.firstChild);
//     }

//     slides = slider.querySelectorAll('.native-ingredients-section__item');
//   }

//   createClones();

//   /* -----------------------------
//      INITIAL POSITION
//   ----------------------------- */

//   function setInitialPosition() {
//     const slideWidth = slides[0].offsetWidth;

//     slider.scrollLeft =
//       slideWidth * slidesPerView;
//   }

//   window.addEventListener('load', setInitialPosition);

//   /* -----------------------------
//      CREATE DOTS
//   ----------------------------- */

//   if (dotsContainer) {
//     const realSlidesCount =
//       slides.length - slidesPerView * 2;

//     for (let i = 0; i < realSlidesCount; i++) {
//       const dot = document.createElement('button');
//       dot.className = 'native-ingredients-section__dot';

//       dot.addEventListener('click', () => {
//         const slideWidth =
//           slides[0].offsetWidth;

//         slider.scrollTo({
//           left:
//             slideWidth *
//             (i + slidesPerView),
//           behavior: 'smooth'
//         });
//       });

//       dotsContainer.appendChild(dot);
//     }
//   }

//   const dots = dotsContainer
//     ? dotsContainer.querySelectorAll('.native-ingredients-section__dot')
//     : [];

//   /* -----------------------------
//      UPDATE ACTIVE DOT
//   ----------------------------- */

//   function updateActiveDot() {
//     if (!dots.length) return;

//     const slideWidth = slides[0].offsetWidth;

//     let index = Math.round(
//       slider.scrollLeft / slideWidth
//     );

//     index = index - slidesPerView;

//     const total =
//       slides.length - slidesPerView * 2;

//     if (index < 0) index = total - 1;
//     if (index >= total) index = 0;

//     dots.forEach(dot =>
//       dot.classList.remove('active')
//     );

//     if (dots[index]) {
//       dots[index].classList.add('active');
//     }
//   }

//   /* -----------------------------
//      LOOP LOGIC (GLITCH-FREE)
//   ----------------------------- */

//   slider.addEventListener('scroll', () => {
//     if (isRepositioning) return;

//     updateActiveDot();

//     clearTimeout(scrollTimeout);

//     scrollTimeout = setTimeout(() => {
//       const slideWidth =
//         slides[0].offsetWidth;

//       const totalRealSlides =
//         slides.length - slidesPerView * 2;

//       const maxScroll =
//         slideWidth *
//         (totalRealSlides + slidesPerView);

//       const minScroll =
//         slideWidth *
//         (slidesPerView - 1);

//       const tolerance = 2;

//       /* RIGHT LOOP */

//       if (
//         slider.scrollLeft >=
//         maxScroll - tolerance
//       ) {
//         reposition(
//           slideWidth * slidesPerView
//         );
//       }

//       /* LEFT LOOP */

//       else if (
//         slider.scrollLeft <=
//         minScroll + tolerance
//       ) {
//         reposition(
//           slideWidth *
//           totalRealSlides
//         );
//       }

//     }, 60);
//   });

//   /* -----------------------------
//      REPOSITION FUNCTION
//   ----------------------------- */

//   function reposition(target) {
//     isRepositioning = true;

//     slider.style.scrollSnapType = 'none';
//     slider.style.scrollBehavior = 'auto';

//     slider.scrollLeft = target;

//     requestAnimationFrame(() => {
//       requestAnimationFrame(() => {

//         slider.style.scrollSnapType = '';
//         slider.style.scrollBehavior = 'smooth';

//         isRepositioning = false;

//       });
//     });
//   }

//   /* -----------------------------
//      FIRST DOT ACTIVE
//   ----------------------------- */

//   if (dots[0]) {
//     dots[0].classList.add('active');
//   }

//   /* -----------------------------
//      RESIZE SAFETY
//   ----------------------------- */

//   window.addEventListener('resize', () => {
//     location.reload();
//   });

// });




// Ingredients Section 2

document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.native-ingredients-section-2');
  if (!section) return;

  const slider = section.querySelector('.native-ingredients-section-2__grid');
  const dotsContainer = section.querySelector('[data-slider-dots]');
  const slides = slider.querySelectorAll('.native-ingredients-section-2__item');

  if (!slider || !dotsContainer || slides.length === 0) return;

  slides.forEach((_, index) => {
    const dot = document.createElement('button');
    dot.className = 'native-ingredients-section-2__dot';

    dot.addEventListener('click', () => {
      const slide = slides[index];
      slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    });

    dotsContainer.appendChild(dot);
  });

  const dots = dotsContainer.querySelectorAll('.native-ingredients-section-2__dot');

  function updateActiveDot() {
    let index = 0;
    const scrollLeft = slider.scrollLeft;

    slides.forEach((slide, i) => {
      if (scrollLeft >= slide.offsetLeft - slide.offsetWidth / 2) {
        index = i;
      }
    });

    dots.forEach(dot => dot.classList.remove('active'));
    if (dots[index]) dots[index].classList.add('active');
  }

  slider.addEventListener('scroll', updateActiveDot);

  if (dots[0]) dots[0].classList.add('active');
});



// Main Product Page Products Gallery

// Product Thumbnail Slider Custom Sync

document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll('media-gallery .thumbnail-slider ul li.slider__slide');
  if (!slides.length) return;

  let currentIndex = 0;
  slides[currentIndex].classList.add('active');

  function goTo(index) {
    currentIndex = (index + slides.length) % slides.length;
    slides[currentIndex].querySelector('button')?.click();
  }

  slides.forEach(slide => {
      slide.addEventListener('click',function(){
        currentIndex = slide.dataset.mediaPosition - 1; 
      })
  });

  document.querySelectorAll('.thumbnail-slider .slider-button').forEach(function (btn) {
    btn.dataset.step=1;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      const step = btn.classList.contains('slider-button--next') ? 1 : -1;
      goTo(currentIndex + step);
    });
  });
});